module.exports = __webpack_public_path__ + "static/media/OneBite1.7dce0101.jpg";